module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('vbl-tree', {
    attrs: {
      "checked": _vm.checked,
      "list": _vm.data,
      "type": "checkbox"
    },
    on: {
      "update:checked": function($event) {
        _vm.checked = $event
      }
    }
  })], 1), _c('br'), _c('div', [_c('vbl-tree', {
    attrs: {
      "checked": _vm.checked,
      "list": _vm.data,
      "type": "radio"
    },
    on: {
      "update:checked": function($event) {
        _vm.checked = $event
      }
    }
  })], 1), _c('br'), _c('div', [_c('vbl-tree', {
    attrs: {
      "checked": _vm.checked,
      "list": _vm.data
    },
    on: {
      "update:checked": function($event) {
        _vm.checked = $event
      }
    }
  })], 1), _c('br'), _c('br'), _c('vbl-button', {
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("选中nnn")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b39651e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblTree/example/vblTreeExample.vue
// module id = 286
// module chunks = 0